import { render, staticRenderFns } from "./SettingsBreadcrumb.vue?vue&type=template&id=5f583a40&scoped=true"
import script from "./SettingsBreadcrumb.vue?vue&type=script&lang=js"
export * from "./SettingsBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f583a40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f583a40')) {
      api.createRecord('5f583a40', component.options)
    } else {
      api.reload('5f583a40', component.options)
    }
    module.hot.accept("./SettingsBreadcrumb.vue?vue&type=template&id=5f583a40&scoped=true", function () {
      api.rerender('5f583a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/breadcrumb/SettingsBreadcrumb.vue"
export default component.exports